import { useForm, Head, Link } from '@inertiajs/react';

export default function ForgotPassword({ errors }) {
  const { data, setData, post, processing } = useForm({
    email_address: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    post('/forgot_password');
  };

  return (
    <>
      <Head title='Forgot Password' />
      <div className='min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-md w-full space-y-8'>
          <div>
            <h2 className='mt-6 text-center text-3xl font-extrabold text-gray-900'>
              Forgot your password?
            </h2>
            <p className='mt-2 text-center text-sm text-gray-600'>
              Enter your email address and we'll send you a link to reset your
              password.
            </p>
          </div>

          <form className='mt-8 space-y-6' onSubmit={handleSubmit}>
            <div className='rounded-md shadow-sm -space-y-px'>
              <div>
                <label htmlFor='email-address' className='sr-only'>
                  Email address
                </label>
                <input
                  id='email-address'
                  name='email_address'
                  type='email'
                  autoComplete='email'
                  required
                  className='appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-[var(--color-yellow-primary)] focus:border-[var(--color-yellow-primary)] focus:z-10 sm:text-sm'
                  placeholder='Email address'
                  value={data.email_address}
                  onChange={(e) => setData('email_address', e.target.value)}
                />
              </div>
            </div>

            {errors.email_address && (
              <div className='text-red-500 text-sm'>{errors.email_address}</div>
            )}

            <div>
              <button
                type='submit'
                className='group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-slate-900 bg-[var(--color-yellow-primary)] hover:bg-[var(--color-yellow-secondary)] hover:text-slate-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-yellow-primary)]'
                disabled={processing}
              >
                Send Reset Link
              </button>
            </div>
            <div className='text-center text-sm'>
              <Link
                href='/login'
                className='font-medium text-slate-600 hover:text-slate-900'
              >
                Back to login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
